import EventGridController from './EventGridController';
import Container from '../lib/gui/dom/Container';
import EpgConstants from './EpgConstants';
import Utils from '../../utils/Utils';
import { EPGUtil } from './EPGUtil';
import TvChannelUtil from '../../utils/TvChannelUtil';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import ResumeController from './ResumeController';
import settings from '../../devices/all/settings';
import EpgFeederManager from '../../AAFPersistenceManager/feeders/EpgFeederManager';
import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import EpgPersistence from './EpgPersistence';
import logger from 'src/utils/logger/logger';
export default class EventController {
  /**
   * Este controlador a su vez administra info sobre tres áreas en pantalla:
   * - Grid de eventos
   * - El indicador / línea vertical de tiempo
   * - La barra superior de tiempo
   */

  /**
   * El controller top de este controller
   */
  epgController;

  /**
   * El controller de eventos en pantalla
   */
  eventGridController;

  /**
   * El contenedor del bar time
   */
  timeBarController;

  /**
   * El contenedor de la barra indicadora del tiempo
   */
  timeIndicatorController;

  constructor(channelList, scheduleList, startTime = null, extraparams = {}) {
    this.channelList = channelList;
    this.scheduleList = scheduleList;
    this.startTime = startTime;
    this.extraparams = extraparams;
    // constructor(parentController) {
    // this.parentController = parentController;
    this.eventGridController = new EventGridController(this);
    this.resumenController = new ResumeController();
    // this.timeIndicatorController = new TimeIndicatorController(this);
    this.mainContainer = null;

    // Esto valor de abajo me lo tiene que pasar EPGController
    this.currentStartTime = null; // En segundos
    this.gridStartTime = null;
    this.groupIds = [];
    this.timeWindowLength =
      EpgConstants.TIMELINE_CELL_SIZE_MS * EpgConstants.TOTAL_TIMELINE_INTERVALS;

    this.onFocusEvent = this.onFocusEvent.bind(this);
    this.onClicEvent = this.onClicEvent.bind(this);
    this.onRecordEvent = this.onRecordEvent.bind(this);
    this.isGridDrawing = this.isGridDrawing.bind(this);
    this.setGridDrawing = this.setGridDrawing.bind(this);

    this.onClickEventCallback = null;
    this.onRecEventCallback = null;
    this.eventFocused = null;
    // this.setResumeCallback = null;
    // En milisegundos
    this.maxTimeshiftAllowAllowedInMs = null;
    this.pressTimer = null;

    this.isDrawing = false;
  }

  isGridDrawing() {
    return this.isDrawing;
  }

  /**
   *
   * @param {*} val boolean
   */
  setGridDrawing(val) {
    this.isDrawing = val;
  }

  paintChannels(gids) {
    if (gids && Array.isArray(this.channelList.getChannelList())) {
      let ArrayGis = gids.map(gi => {
        return this.channelList.getChannelList().find(el => el.group_id === gi);
      });
      this.channelList.functionPaint(ArrayGis);
    }
  }

  /**
   *
   * @param {*} parentElement AAF Element instance to add this child to
   */
  initialise(parentElement) {
    this.resumenController.initialise('resume-wrapper');
    this.mainContainer = new Container(parentElement, {
      className: 'event-list-group',
      id: 'eventListGroup'
    });
    this.eventGridController.initialise(this.mainContainer);
    this.eventGridController.setFocusedEventCallback(this.onFocusEvent);
    this.eventGridController.setClickedEventCallback(this.onClicEvent);
    this.eventGridController.setRecordEventCallback(this.onRecordEvent);
    // Se inicializa el tiempo de inicio del Grid
    this.setWindowStartTimeNow();
  }

  getCurrentChannelPlaying() {
    return TvChannelUtil.getLastChannel();
  }

  setOnClickEventCallback(cbk) {
    this.onClickEventCallback = cbk;
  }

  setOnRecEventCallback(cbk) {
    this.onRecEventCallback = cbk;
  }

  async onFocusEvent(event) {
    if (event && settings.enable_resume_persistance) {
      this.eventFocused = event;
      let nevent = null;
      if (EPGUtil.isFullEvent(event)) {
        nevent = { ...event };
      } else {
        nevent = await EPGUtil.getEventByEventId(event.id_composite, event.id, event.group_id);
        this.eventFocused = nevent;
      }
      //YUNI: asi se ejecuta en epgPostalesFull.
      //El metodo de origen es en epg/container linea 788 aprox.
      // this.props.onSetCurrentData({channel, event, focused});
      // this.setResumeCallback({event: nevent});
      clearTimeout(this.pressTimer);
      this.pressTimer = setTimeout(() => {
        this.resumenController.setResume(nevent);
      }, EpgConstants.TIMEOUT_RESUME);
      logger.debug('[NEPG] EVENTGRID EventController onFocusEvent ', nevent);
    } else {
      clearTimeout(this.pressTimer);
      this.resumenController.clean();
      this.eventFocused = null;
    }
  }

  onRecordEvent(event) {
    if (this.onRecEventCallback) {
      this.onRecEventCallback(event);
    }
  }

  async onClicEvent(event) {
    let isCurrent = this.eventIsCurrent(event);
    let currentEvent = null;
    if(this.extraparams && (typeof this.extraparams.getCurrentEvent === 'function')){
      currentEvent = this.extraparams.getCurrentEvent();
    }

    let isPastEvent = false;
    let isFutureEvent = false;
    if (isCurrent) {
      // Cambio de canal
      if (event.group_id !== this.getCurrentChannelPlaying() || (currentEvent && currentEvent.id && event.id && (event.group_id === this.getCurrentChannelPlaying()) && (currentEvent.id !== event.id))) {
        if (this.onClickEventCallback) {
          this.onClickEventCallback(isCurrent, isPastEvent, isFutureEvent, event);
        }
      }
    } else {
      isPastEvent = this.eventIsPast(event);
      if (!isPastEvent) {
        isFutureEvent = this.eventIsFuture(event);
      }
      // Go ficha
      if (isPastEvent || isFutureEvent) {
        if (this.onClickEventCallback) {
          //traer la data del evento
          let nevent = null;
          if (EPGUtil.isFullEvent(event)) {
            nevent = { ...event };
          } else {
            nevent = await EPGUtil.getEventByEventId(event.id_composite, event.id, event.group_id);
          }
          this.onClickEventCallback(isCurrent, isPastEvent, isFutureEvent, nevent);
        }
      }
    }
  }

  eventIsCurrent(event) {
    if (event && event.date_begin) {
      const _now = Utils.nowAsTimestampSeconds();
      return event.date_begin <= _now && event.date_end >= _now;
    }

    return false;
  }

  eventIsPast(event) {
    if (event && event.date_end) {
      const _now = Utils.nowAsTimestampSeconds();
      return _now > event.date_end;
    }

    return false;
  }

  eventIsFuture(event) {
    if (event && event.date_begin) {
      const _now = Utils.nowAsTimestampSeconds();
      return event.date_begin > _now;
    }

    return false;
  }

  setLoading(opacity) {
    this.eventGridController.setLoading(opacity);
  }

  // setResume(callback){
  //     this.setResumeCallback = callback;
  // }

  setWindowStartTimeNow() {
    const _nao = (this.startTime || Utils.nowAsTimestampSeconds()) * 1000;
    this.currentStartTime = this.floorTimeToHalfHour(_nao) / 1000;
    //console.log('[NEPG] EVENTGRID setWindowStartTimeNow > ', new Date(this.currentStartTime * 1000));
    //this.updateWindowStartTime(EpgConstants.GRIDEVENT_RIGHT_NAVIGATION);
  }

  /**
   * En el caso de ott el max de días a navegar a la derecha
   * @returns
   */
  getDaysRightNavigationEpg() {
    try {
      let metadataKey = Metadata.get('days_to_insert_epg','{"default":{"days":8}}');
      metadataKey = JSON.parse(metadataKey);
      const region = DeviceStorage.getItem('region');

      return metadataKey[region] || metadataKey['default'];
    }
    catch(e) {
      return { days: 8 };
    }
  }

  // Recuperar el endtime del último evento en la BD
  getLatestRightEventTime() {
    const maxRight = this.getDaysRightNavigationEpg();
    let _now = Utils.nowAsTimestampSeconds();
    let defaultLatestTime = _now + (maxRight.days * 24 * 60 * 60);
    let latestTime = null;
    if(EpgPersistence.isDatabaseDataSource()) {
      latestTime = new EpgFeederManager().getEpgDBEndTime(true);
    }

    return latestTime || defaultLatestTime;
  }

  // Recuperar el último evento o máxima fecha que buscaremos a la izquierda
  async getLatestLeftEventTime() {
    // Trabajar con milisegundos es más exacto? después regresar segundos ¿?
    let _now = Utils.nowAsTimestampSeconds() * 1000;
    //console.log('[GED] getLatestLeftEventTime _now: ', _now);
    if (this.maxTimeshiftAllowAllowedInMs === null) {
      //console.log('[GED] entra 1 ');
      let maxTimeshiftAllow = await new ChannelSingleton().getMaxTimeshift();
      //console.log('[GED] maxTimeshiftAllow', maxTimeshiftAllow);
      if (!isNaN(maxTimeshiftAllow) && maxTimeshiftAllow > 0) {
        // Channel singleton regresa minutos, pasarlo a segundos (y luego a milis para hacer los cálculos)
        //maxTimeshiftAllow = maxTimeshiftAllow * 60; // Fix, sigleton ya lo regresa en segundos
        this.maxTimeshiftAllowAllowedInMs = maxTimeshiftAllow * 1000; // timeshift viene en segundos
      } else {
        this.maxTimeshiftAllowAllowedInMs = 0;
      }
    }

    if (this.maxTimeshiftAllowAllowedInMs > 0) {
      //console.log('[GED] maxTimeshiftAllowAllowedInMs es mayor a 0, _now, this.maxTimeshiftAllowAllowedInMs, now - maxtimeshift: ', _now, this.maxTimeshiftAllowAllowedInMs,(this.floorTimeToHalfHour(_now - this.maxTimeshiftAllowAllowedInMs) / 1000));
      return this.floorTimeToHalfHour(_now - this.maxTimeshiftAllowAllowedInMs) / 1000;
    } else {
      return this.floorTimeToHalfHour(_now) / 1000;
    }
  }

  async updateGridTime(direction) {
    let ret = false;
    switch (direction) {
      case EpgConstants.GRIDEVENT_RIGHT_NAVIGATION:
        if (this.getEndTime() < (await this.getLatestRightEventTime())) {
          this.currentStartTime =
            (this.currentStartTime * 1000 + this.getTimeWindowLength()) / 1000;
          ret = true;
        }
        if (ret) {
          logger.debug(
            '[GED] Next right window start in: ',
            this.currentStartTime,
            ' - RIGHT GRID UPDATE'
          );
        } else {
          logger.debug(
            '[GED] Next right window in: ',
            this.currentStartTime,
            ' - RIGHT DONT GRID UPDATE'
          );
        }
        break;
      case EpgConstants.GRIDEVENT_LEFT_NAVIGATION:
        let latestEv = await this.getLatestLeftEventTime();
        if (this.getStartTime() > latestEv) {
          this.currentStartTime =
            (this.currentStartTime * 1000 - this.getTimeWindowLength()) / 1000;
          ret = true;
        }
        if (ret) {
          logger.debug(
            '[GED] Next left window start in: ',
            this.currentStartTime,
            ' - LEFT GRID UPDATE'
          );
        } else {
          logger.debug(
            '[GED] Next left window start in: ',
            this.currentStartTime,
            ' - LEFT DONT GRID UPDATE'
          );
        }
        break;
      default:
        break;
    }

    return ret;
  }

  hasLeftNavigation() {
    let _now = Utils.nowAsTimestampSeconds() * 1000;
    let max = 0;

    if (this.maxTimeshiftAllowAllowedInMs > 0) {
      //console.log('[GED] maxTimeshiftAllowAllowedInMs es mayor a 0, _now, this.maxTimeshiftAllowAllowedInMs, now - maxtimeshift: ', _now, this.maxTimeshiftAllowAllowedInMs,(this.floorTimeToHalfHour(_now - this.maxTimeshiftAllowAllowedInMs) / 1000));
      max = this.floorTimeToHalfHour(_now - this.maxTimeshiftAllowAllowedInMs) / 1000;
    } else {
      max = this.floorTimeToHalfHour(_now) / 1000;
    }
    return this.getStartTime() > max;
  }

  // Para encontrar el time
  floorTimeToHalfHour(time) {
    return time - (time % EpgConstants.TIMELINE_CELL_SIZE_MS);
  }

  floorTimeToWindowSize(time) {
    return time - (time % this.timeWindowLength);
  }

  /**
   *
   * @param {*} groupIds
   * @param {*} _startTime
   * @param {*} _endTime
   * @param {*} keyDirection
   */
  drawGrid(groupIds, _startTime, _endTime, keyDirection) {
    if (this.isDrawing) {
      logger.debug('[NEPG] EventController.drawGrid> rejected, isDrawing = true, no pinta');
      return;
    }
    logger.debug('[NEPG] EventController.drawGrid> rejected, isDrawing = false, pinta');
    this.isDrawing = true;

    this.groupIds = groupIds;
    let startTime = _startTime || this.getStartTime();
    let endTime = _endTime || this.getEndTime();

    this.eventGridController.draw(this.groupIds, startTime, endTime, keyDirection);
  }

  // Window startTime
  setStartTime(currentStartTime) {
    this.currentStartTime = currentStartTime;
  }

  getCurrentGroupdIds() {
    return this.groupIds;
  }

  // Window startTime
  getStartTime() {
    return this.currentStartTime;
  }

  getTimeWindowLength() {
    // Esto esta en milisegundos
    return this.timeWindowLength;
  }

  getRowsPerGrid() {
    return EpgConstants.TOTAL_ROWS_CHANNEL_GRID;
  }

  getEndTime() {
    return this.currentStartTime + this.getTimeWindowLength() / 1000;
  }

  isInCurrentWindow(time) {
    return time >= this.currentStartTime && time < this.getEndTime();
  }

  isEventInCurrentWindow(event) {
    return this.isInCurrentWindow(event.startTime) || this.isInCurrentWindow(event.endTime);
  }

  getCurrentChannelIndex() {
    return this.channelList.getCurrentIndex();
  }

  eventDown(repeats) {
    this.channelList.eventDown(repeats);
  }

  eventUp(repeats) {
    this.channelList.eventUp(repeats);
  }

  /**
   * @param {*} keyName Nombre de la tecla presionada
   * @param {*} event Evento de la tecla presionada
   * @param {*} repeats true si esta en modo desesperado
   * @returns
   * @memberof ChannelController
   */
  keyHandler(keyName, event, repeats) {
    return this.eventGridController.keyHandler(keyName, event, repeats);
  }

  moveStepRightSchedule() {
    this.scheduleList.movePageRight();
  }

  moveStepLeftSchedule() {
    //this.scheduleList.move(this.getStartTime() * 60);
    this.scheduleList.movePageLeft();
  }

  deactivate() {
    this.eventGridController.deactivate();
    this.resumenController.destroy();
  }
}



// WEBPACK FOOTER //
// ./src/AAF/Nepg/EventController.js